<template>
    <div>
        <h4>Select a driver to assign</h4>
        <div class="driver-selection">
            <md-field>
                <label>Driver</label>
                <md-select v-model="driverIdModel" md-no-validate>
                    <md-option v-for="member in teamMembers" :key="member.publicUserId" :value="member.publicUserId">
                        {{ member.firstName }} {{ member.lastName }}
                    </md-option>
                </md-select>
            </md-field>
        </div>
    </div>
</template>

<script>
import { showErrorMessage } from '@/helpers';

export default {
    name: 'AssignDriver',
    props: {
        selectedDriverId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            teamMembers: []
        };
    },
    computed: {
        driverIdModel: {
            get() {
                return this.selectedDriverId;
            },
            set(value) {
                this.$emit('driver-selected', value);
            }
        }
    },
    async mounted() {
        await this.fetchTeamMembers();
    },
    methods: {
        async fetchTeamMembers() {
            try {
                const teamMembers = await this.$store.dispatch('team/FETCH_TEAM_MEMBERS');
                this.teamMembers = teamMembers;
            } catch (error) {
                showErrorMessage(this, 'Failed to load team members', error);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.driver-selection {
    margin-top: 20px;
    max-width: 300px;
}

/* Fix for dropdown text visibility */
::v-deep .md-select {
    .md-select-value {
        color: #000 !important;
    }

    .md-menu-content {
        .md-list-item-content {
            color: #000 !important;
        }
    }
}

::v-deep .md-input {
    -webkit-text-fill-color: #000 !important;
}

::v-deep .md-menu-content {
    .md-list {
        .md-list-item-content {
            color: #000 !important;
        }
    }
}
</style>
